// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:48 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class FeatureSetServiceInterface {
  constructor() {
    this.service_id = 'featuresetservice-1_1';
  }

  // getFeatureSet, Response: GetFeatureSetResponse
  // appId: String
  // tenancyId: int
  getFeatureSet(appId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetFeatureSet', { appId: appId, tenancyId: tenancyId }, success_callback);
  }

  // getFeatureSetByUrl, Response: FeatureSetByUrlResponse
  // url: String
  getFeatureSetByUrl(url, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'FeatureSetByUrlRequest', { url: url }, success_callback);
  }

  // FeatureStatusByTenancyRequest
  // tenancyId: Integer
  // onlyTenancySpecific: Boolean (defaults to false)
  getFeatureStatusByTenancy(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'FeatureStatusByTenancyRequest', request, success_callback);
  }

  // AvailableFeaturesRequest
  getAvailableFeatures(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'AvailableFeaturesRequest', request, success_callback);
  }

  // EnableFeatureForTenancy
  // tenancyId: Integer
  // feature: Feature(featureName, featureDescription)
  enableFeatureForTenancy(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'EnableFeatureForTenancy', request, success_callback);
  }

  // DisableFeatureForTenancy
  // tenancyId: Integer
  // feature: Feature(featureName, featureDescription)
  // unsetFeature: Boolean (defaults to true)
  disableFeatureForTenancy(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DisableFeatureForTenancy', request, success_callback);
  }

  getFeatureSetByEntityId(entity_type, entity_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'FeatureSetByEntityLicenseRequest', { type: entity_type, entityId: entity_id }, success_callback);
  }
}

export const featureSetService = new FeatureSetServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/featuresetservice.js
// module id = 3h9S
// module chunks = 1 2 3 4 5 6